import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  IconButton,
  InputAdornment,
  Typography,
  TextField,
  Paper,
  Autocomplete,
} from "@mui/material";
import {
  Close as CloseIcon,
  Search as SearchIcon,
  TaskAlt as TaskAltIcon,
  EditOutlined as EditOutlinedIcon,
  ChevronLeftOutlined,
} from "@mui/icons-material";
import ReviewTable from "./ReviewTable";
import { makeStyles } from "@mui/styles";
import AlertService from "../../../../services/console_services/Alerts";
import { connect } from "react-redux";
import { useMsal } from "@azure/msal-react";
import Loading from "../../Loading";
import { useSelector } from "react-redux";
import CachedIcon from "@mui/icons-material/Cached";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: "auto",
    minHeight: "80vh",
    borderRadius: "8px !important",
    background: "#FFF",
    boxShadow:
      "0px 1px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 16px 0px rgba(0, 0, 0, 0.10)",
    padding: "20px",
    border: "0px !important",
    overflowY: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0px 10px",
  },
  title: {
    display: "flex",
    alignItems: "center",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    lineHeight: "20px !important",
    fontFamily: "Poppins, sans-serif",
  },
  notificationBadge: {
    width: "20px",
    height: "20px",
    borderRadius: "50px",
    backgroundColor: "#DCE0EA",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "10px !important",
    marginLeft: "10px",
    fontWeight: "500 !important",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    margin: "0px 20px",
  },
  textField: {
    width: "400px",
    "& .MuiInputBase-input": {
      height: "15px",
      borderRadius: "20px",
      fontSize: "12px !important",
      borderColor: "transparent",
    },
  },
  iconButton: {
    color: theme.palette.grey[500],
  },
  backButton: {
    color: theme.palette.grey[500],
    boxShadow: "0px 0px 1px black",
    marginRight: "10px !important",
  },
  feedbackContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    color: "#FE5000",
    marginTop: "40px",
    marginRight: "15px",
  },
  feedbackButton: {
    borderRadius: "4px !important",
    border: "1px solid var(--Neutral-Colors-Charcoal-Grey, #404041) !important",
    background: "#fff !important",
    color: "#333 !important",
    margin: "0px 10px !important",
    fontSize: "13px !important",
    textTransform: "none !important",
  },
  markAsReadButton: {
    background: "#2B5692 !important",
    color: "#FFF !important",
    fontSize: "13px !important",
    textTransform: "none !important",
    borderRadius: "4px !important",
    width: "180px !important",
  },
  markAllContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    color: "#FE5000",
    marginTop: "0px",
    marginRight: "15px",
  },
  taskIcon: {
    fontSize: "12px !important",
    marginRight: "5px",
  },
  markAllText: {
    cursor: "pointer",
    fontSize: "12px !important",
    fontWeight: "500 !important",
    color: "#FE5000 !important",
    fontFamily: "Poppins, sans-serif",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  filtersContainer: {
    display: "flex",
    gap: "10px",
    margin: "10px 20px",
  },
  filterDropdown: {
    width: "200px",
    "& .MuiInputBase-root": {
      fontSize: "12px !important",
    },
  },
  clearButton: {
    minWidth: "32px !important",
    height: "32px",
    padding: "6px !important",
    border: "1px solid #ddd !important",
    borderRadius: "8px !important",
    color: "#666 !important",
    "&:hover": {
      backgroundColor: "#f5f5f5 !important",
    },
    "@media (max-width: 768px)": {
      width: "100%",
      height: "40px",
    },
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    height: "56px", // Match dropdown height
  },
}));

function Alerts({
  open,
  handleAlertClose,
  openEdit,
  handleEditClick,
  tabIndex,
  Network,
  DC,
  Products,
  Customers,
  _periodType,
  PL3,
  _date,
  Division,
  applyFilter,
  role,
  onSave,
  setOnsave,
  handleViewPowerBi,
  Temperature,
  fromState,
  toState,
  fromZip,
  toZip,
  lane,
}) {
  const classes = useStyles();
  const { instance } = useMsal();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showFeedback, setShowFeedback] = useState(false);
  const [showFeedbackSuccess, setShowFeedbackSuccess] = useState(false);
  const [selected, setSelected] = useState([]);
  const [alertsRows, setAlertsRows] = useState([]);
  const [viewAllAlertData, setViewAllAlertData] = useState([]);
  const [feedBackComment, setFeedBackComment] = useState("");
  const [alertLoading, setAlertLoading] = useState(true);
  const [commentFlag, setCommentFlag] = useState(false);
  const [reviewComment, setReviewComment] = useState("");
  const { tabName } = useSelector((state) => state?.tabs);
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [selectedName, setSelectedName] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedFunction, setSeletedFunction] = useState(null);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [selectedInsightType, setSelectedInsightType] = useState(null);
  const activeFlagValue = useSelector((state) => state?.filter?.activeFlag);
  const selectedScenarios = useSelector(
    (state) => state?.filter?.selectedScenarios,
  );
  const recomFlag = useSelector((state) => state?.filter?.recomFlag);
  const entireState = useSelector((state) => state);

  var tempFix = tabName;

  if (tabName === "Deployment Optimization") {
    tempFix = "DO";
  } else if (tabName === "Deployment Planning") {
    tempFix = "DP";
  } else if (tabName === "FG Salvage") {
    tempFix = "FGS";
  } else if (tabName === "Capacity Planning" || tabName === "CP") {
    tempFix = "CP";
  } else if (tabName === "Distribution_Planning") {
    tempFix = "DIP";
  } else if (tabName === "Potential Out Of Stock") {
    tempFix = "POOS";
  } else if (tabName === "RR") {
    tempFix = "RR";
  } else if (tabName === "FF") {
    tempFix = "FF";
  } else if (tabName === "Network Planning Simulation") {
    tempFix = "NPS";
  } else if (tabName === "SLP") {
    tempFix = "SLP";
  }

  const filterOptions = useMemo(
    () => ({
      metrics: [...new Set(viewAllAlertData?.map((item) => item?.Metric))]
        ?.map((item) => ({
          label: item?.replace(/_/g, " "),
          value: item,
        }))
        .sort((a, b) => a?.label?.localeCompare(b.label)),

      names: [...new Set(viewAllAlertData?.map((item) => item?.Name || ""))]
        ?.map((item) => ({
          label: item?.replace(/_/g, " "),
          value: item,
        }))
        .sort((a, b) => a?.label?.localeCompare(b?.label)),

      entities: [...new Set(viewAllAlertData?.map((item) => item?.Entity))]
        ?.map((item) => ({
          label: item?.replace(/_/g, " "),
          value: item,
        }))
        .sort((a, b) => a?.label?.localeCompare(b?.label)),

      functions: [...new Set(viewAllAlertData?.map((item) => item?.Function))]
        ?.map((item) => ({
          label: item?.replace(/_/g, " "),
          value: item,
        }))
        .sort((a, b) => a?.label?.localeCompare(b?.label)),

      networks: [...new Set(viewAllAlertData?.map((item) => item?.Network))]
        ?.map((item) => ({
          label: item?.replace(/_/g, " "),
          value: item,
        }))
        .sort((a, b) => a?.label?.localeCompare(b?.label)),

      insightTypes: [
        ...new Set(viewAllAlertData?.map((item) => item?.Insight_Type)),
      ]
        ?.map((item) => ({
          label: item?.replace(/_/g, " "),
          value: item,
        }))
        .sort((a, b) => a?.label?.localeCompare(b?.label)),
    }),
    [viewAllAlertData],
  );

  const handleClearFilters = () => {
    setSelectedMetric(null);
    setSelectedName(null);
    setSelectedEntity(null);
    setSeletedFunction(null);
    setSelectedNetwork(null);
    setSelectedInsightType(null);
  };

  const getViewAllAlertData = async () => {
    let module = tempFix;
    let params = {
      module: tempFix,
      filter: {
        RecommendedDC: DC,
        Network,
        PL3,
        Division,
        MaterialID: Products,
        Customers,
        ScenarioName:
          entireState?.filter?.scenarioValue === ""
            ? []
            : [entireState?.filter?.scenarioValue],
      },
    };

    if (module === "DO" || module === "DP") {
      params.filter = {
        RecommendedDC: DC,
        Network,
        PL3,
        Division,
        MaterialID: Products,
      };
    } else if (module === "POOS") {
      params.filter.ActiveFlag = activeFlagValue;
    } else if (module === "RR") {
      params.acceptCondition = recomFlag;
      params.scenarioCondition = selectedScenarios?.map((item) => item?.value);
    } else if (module === "FF") {
      params.filter = {
        Network,
        temperature: Temperature,
        Source_State: fromState,
        Destination_State: toState,
        Source_3zip: fromZip,
        Destination_3zip: toZip,
        lane: lane,
      };
    } else {
      if (Network) {
        params.filter.Network = Network;
      }
      if (DC) {
        params.filter.RecommendedDC = DC;
      }
    }
    try {
      setAlertLoading(true);
      const data = await AlertService.getAllAlertsAtViewAll(params, instance);
      setViewAllAlertData(data.data);
      setAlertsRows(data.data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setAlertLoading(false);
    }
  };
  useEffect(() => {
    if (open) {
      getViewAllAlertData();
      setOnsave(false);
    }
  }, [
    open,
    tabIndex,
    role,
    applyFilter,
    openEdit,
    entireState?.filter?.scenarioValue,
    activeFlagValue,
  ]);

  useEffect(() => {
    if (onSave) {
      const timer = setTimeout(() => {
        getViewAllAlertData();
        setOnsave(false);
      }, 2000); // 2000 milliseconds = 5 seconds
      return () => clearTimeout(timer);
    }
  }, [onSave]);

  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchQuery("");
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    setSearchTerm(query);
  };

  const handleShowFeedback = (value) => {
    setShowFeedback(value);
  };

  const handleFeedbackClose = () => {
    setAlertsRows(viewAllAlertData);
    setShowFeedback(false);
    setSelected([]);
    setCommentFlag(false);
  };

  const getMarkAsReviewed = () => {
    const rowData = selected.length > 1 ? viewAllAlertData : alertsRows;
    const isReviewed = rowData.filter((row) => row.Review_Flag !== 1);
    const alertDetailsArray = isReviewed.map((item) => {
      return {
        Name: item.Name,
        EntityType: item?.Entity,
        AlertType: item?.Metric,
        AlertValue: item?.Metric_value,
        comments: feedBackComment,
      };
    });
    const params = {
      alertDetailsArray,
      module: tempFix,
    };
    AlertService.markAsReviewed(params, instance)
      .then((_data) => {
        // handle success
      })
      .catch((error) => console.error("Error:", error));
  };

  const handleMarkReviewed = () => {
    getMarkAsReviewed();
    setShowFeedbackSuccess(true);
    setShowFeedback(false);
    setTimeout(() => {
      setShowFeedbackSuccess(false);
      setAlertsRows(viewAllAlertData);
      setFeedBackComment("");
      setSelected([]);
      getViewAllAlertData();
      setCommentFlag(false);
    }, 2000);
  };

  const handleMarkAllReviewed = () => {
    setSelected(viewAllAlertData.map((row) => row.Alert_id));
    setShowFeedback(true);
    setAlertsRows([]);
    getMarkAsReviewed();
    setCommentFlag(false);
    setReviewComment("");
  };

  const handleCheckboxClick = (selectedCheckboxID, isChecked) => {
    setSelected([selectedCheckboxID]);
    if (isChecked) {
      setAlertsRows(
        viewAllAlertData.filter((row) => row.Alert_id === selectedCheckboxID),
      );
    } else {
      setAlertsRows(viewAllAlertData);
    }
  };

  const handleFeedBackChange = (value) => {
    setFeedBackComment(value);
  };

  const getUnReviewedAlerts = () => {
    return viewAllAlertData.filter((item) => item.Review_Flag === 0).length;
  };

  const filteredRows = useMemo(
    () =>
      alertsRows?.filter((row) => {
        const lowerSearchQuery = searchQuery.toLowerCase();
        const matchesSearch =
          row?.Entity?.toLowerCase().includes(lowerSearchQuery) ||
          row?.Metric?.toLowerCase().includes(lowerSearchQuery) ||
          row?.Name?.toLowerCase().includes(lowerSearchQuery) ||
          row?.Metric_value?.toString().includes(lowerSearchQuery) ||
          row?.Genrated_date?.toLowerCase().includes(lowerSearchQuery) ||
          row?.Function?.toLowerCase().includes(lowerSearchQuery) ||
          row?.Network?.toLowerCase().includes(lowerSearchQuery) ||
          row?.Insight_Type?.toLowerCase().includes(lowerSearchQuery);

        const matchesMetric = selectedMetric
          ? row.Metric === selectedMetric
          : true;
        const matchesName = selectedName ? row.Name === selectedName : true;
        const matchesEntity = selectedEntity
          ? row.Entity === selectedEntity
          : true;
        const matchesFunction = selectedFunction
          ? row?.Function === selectedFunction
          : true;
        const matchesNetwork = selectedNetwork
          ? row?.Network === selectedNetwork
          : true;
        const matchesInsightType = selectedInsightType
          ? row?.Insight_Type === selectedInsightType
          : true;

        return (
          matchesSearch &&
          matchesMetric &&
          matchesName &&
          matchesEntity &&
          matchesFunction &&
          matchesNetwork &&
          matchesInsightType
        );
      }),
    [
      alertsRows,
      searchQuery,
      selectedMetric,
      selectedName,
      selectedEntity,
      selectedFunction,
      selectedNetwork,
      selectedInsightType,
    ],
  );

  const handleComment = (id, comment) => {
    if (!commentFlag) {
      setAlertsRows(viewAllAlertData?.filter((row) => row?.Alert_id === id));
    } else {
      setAlertsRows(viewAllAlertData);
    }
    setShowFeedback(!showFeedback);
    setReviewComment(comment);
    setCommentFlag(!commentFlag);
  };

  const FilterDropdown = ({ label, options, value, onChange }) => (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option?.label}
      value={options?.find((opt) => opt?.value === value) || null}
      onChange={(_, newValue) => onChange(newValue ? newValue?.value : null)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          size="small"
          className={classes.filterDropdown}
          sx={{
            width: "200px",
            "& .MuiInputLabel-root": {
              fontSize: "11px",
            },
          }}
        />
      )}
      freeSolo
      filterOptions={(options, { inputValue }) =>
        options?.filter((option) =>
          option?.label?.toLowerCase()?.includes(inputValue?.toLowerCase()),
        )
      }
      disablePortal
      disableClearable
    />
  );

  return (
    <>
      {open && (
        <Paper className={classes.paper}>
          <div className={classes.header}>
            <IconButton
              aria-label="close"
              onClick={handleAlertClose}
              className={classes.backButton}
            >
              <ChevronLeftOutlined color="rgb(0, 103, 161)" />
            </IconButton>
            <Typography className={classes.title}>
              {showFeedback ? (
                "Review Alert"
              ) : (
                <>
                  {tabName === "RR"
                    ? "Action Items"
                    : tabName === "IF"
                      ? "Insights"
                      : "Alerts"}
                  <span className={classes.notificationBadge}>
                    {getUnReviewedAlerts()}
                  </span>
                </>
              )}
            </Typography>
            <div
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              {!showFeedback && (
                <>
                  <span className={classes.searchContainer}>
                    <div className={classes.filtersContainer}>
                      <Button
                        variant="outlined"
                        onClick={handleClearFilters}
                        className={classes.clearButton}
                        title="Clear all filters"
                      >
                        <CachedIcon fontSize="small" />
                      </Button>
                      {window.location.pathname === "/if" ? (
                        <>
                          <FilterDropdown
                            label="Function"
                            options={filterOptions?.functions}
                            value={selectedFunction}
                            onChange={setSeletedFunction}
                          />
                          <FilterDropdown
                            label="Network"
                            options={filterOptions.networks}
                            value={selectedNetwork}
                            onChange={setSelectedNetwork}
                          />
                          <FilterDropdown
                            label="Insight Type"
                            options={filterOptions?.insightTypes}
                            value={selectedInsightType}
                            onChange={setSelectedInsightType}
                          />
                        </>
                      ) : (
                        <>
                          <FilterDropdown
                            label="Entity"
                            options={filterOptions.entities}
                            value={selectedEntity}
                            onChange={setSelectedEntity}
                          />
                          <FilterDropdown
                            label="Entity Name"
                            options={filterOptions.names}
                            value={selectedName}
                            onChange={setSelectedName}
                          />
                          <FilterDropdown
                            label="Alert Type"
                            options={filterOptions.metrics}
                            value={selectedMetric}
                            onChange={setSelectedMetric}
                          />
                        </>
                      )}
                    </div>
                    <TextField
                      hiddenLabel
                      id="search-input"
                      placeholder="search"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      variant="outlined"
                      size="small"
                      className={classes.textField}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchTerm ? (
                              <IconButton
                                aria-label="clear search"
                                onClick={handleClearSearch}
                                size="small"
                                className={classes.iconButton}
                              >
                                <CloseIcon
                                  fontSize="small"
                                  style={{ color: "#d1d0d0" }}
                                />
                              </IconButton>
                            ) : (
                              <SearchIcon
                                fontSize="small"
                                style={{ color: "#d1d0d0" }}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: "100%" }}
                    />
                  </span>
                  <IconButton
                    aria-label="edit"
                    onClick={handleEditClick}
                    className={classes.iconButton}
                  >
                    <EditOutlinedIcon />
                  </IconButton>
                </>
              )}
            </div>
          </div>
          {alertLoading ? (
            <div className={classes.loader}>
              <Loading />
            </div>
          ) : (
            <>
              <ReviewTable
                alertsRows={filteredRows}
                open={open}
                showFeedback={showFeedback}
                handleShowFeedback={handleShowFeedback}
                selected={selected}
                handleCheckboxClick={handleCheckboxClick}
                searchQuery={searchQuery}
                showFeedbackSuccess={showFeedbackSuccess}
                feedBackComment={feedBackComment}
                handleFeedBackChange={handleFeedBackChange}
                handleComment={handleComment}
                commentFlag={commentFlag}
                reviewComment={reviewComment}
                handleViewPowerBi={handleViewPowerBi}
                setFeedBackComment={setFeedBackComment}
                viewAllAlertData={viewAllAlertData}
              />
              {showFeedback && !reviewComment && (
                <div className={classes.feedbackContainer}>
                  <Button
                    variant="contained"
                    onClick={handleFeedbackClose}
                    className={classes.feedbackButton}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    onClick={handleMarkReviewed}
                    className={classes.markAsReadButton}
                  >
                    Mark As Reviewed
                  </Button>
                </div>
              )}
              {selected.length === 0 &&
                !commentFlag &&
                window.location.pathname !== "/if" && (
                  <div className={classes.markAllContainer}>
                    <TaskAltIcon className={classes.taskIcon} />
                    <Typography
                      className={classes.markAllText}
                      onClick={handleMarkAllReviewed}
                    >
                      Mark All as Read
                    </Typography>
                  </div>
                )}
            </>
          )}
        </Paper>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  periodType: state.filter.periodType,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
  Temperature: state.filter.Temperature,
  Customers: state.filter.Customers,
  fromState: state.filter.fromState,
  toState: state.filter.toState,
  fromZip: state.filter.fromZip,
  toZip: state.filter.toZip,
  lane: state.filter.lane,
});

export default connect(mapStateToProps)(Alerts);
